<template>
  <b-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
    draggable
    @dragstart="dragstart"
    @drop="drop"
    @dragover="dragover"
    @dragleave="dragleave"
  >
    <template slot-scope="props">
      <b-table-column field="active" label="Ativo">
        <b-icon
          v-if="props.row.active"
          size="is-small"
          icon="check"
          type="is-success"
        ></b-icon>
        <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
      </b-table-column>

      <b-table-column label="Imagem">
        <img :src="props.row.image" alt="Imagem do Banner" />
      </b-table-column>

      <b-table-column field="type" label="Login">
        <b-icon
          v-if="isLoginType(props.row.type)"
          size="is-small"
          icon="check"
          type="is-success"
        ></b-icon>
        <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
      </b-table-column>
      <b-table-column label="Opções">
        <button
          v-if="page >= 2 && props.index == 0"
          @click="moveToPreviousPage(props.row)"
          v-app-button.icon-only
          title="Mover para cima"
        >
          <b-icon size="is-small" icon="arrow-up"></b-icon>
        </button>
        <router-link
          :to="`${props.row.id}/edit`"
          tag="button"
          type="button"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </router-link>
        <button
          @click="onClickDeleteBanner(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Excluir'"
          color="danger"
        >
          <b-icon size="is-small" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import BannerService from '@/services/banner.service';
import { BannerTypeEnum } from '@/enums/BannerTypeEnum';
import ToastMixin from '@/mixins/ToastifyMixin';
import DraggableTableMixin from '@/mixins/DraggableTableMixin';

export default {
  name: 'banners-table',
  mixins: [ToastMixin, DraggableTableMixin],
  data: () => {
    return {
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      BannerService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Banners.', 'error'))
        .finally(() => (this.loading = false));
    },
    onClickDeleteBanner(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Banner',
        message:
          'Tem certeza que deseja <b>excluir</b> este banner? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Banner',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteBanner(id),
      });
    },
    deleteBanner(id) {
      BannerService.delete(id)
        .then(() => {
          this.toastify('Banner excluído com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Banner.',
            'error'
          );
        });
    },
    onOrderChange(bannerId, from, to) {
      const replaceOrder = this.data[to].order;
      this.data = this.reorderArray(this.data, from, to);

      BannerService.reorder(bannerId, replaceOrder)
        .then(() => this.toastify('Ordem atualizada!'))
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao atualizar os banners.',
            'error'
          );
        })
        .finally(() => this.load());
    },
    moveToPreviousPage(banner) {
      BannerService.moveUp(banner.id).then(() => this.load());
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
    isLoginType(type) {
      return type == BannerTypeEnum.LOGIN;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
td > img {
  max-height: 80px;
}
</style>
